export const RECOMMENDATIONS_IMAGE_ASPECT_RATIO = 0.75;
